import React from 'react'
import { Link } from 'react-router-dom'
import SEO from '../seo/SEO'

const NotFound: React.FC = () => (
  <>
    <SEO title="Page not found | MakeMyDay" />
    <section className="mission-section">
      <div className="container text-center">
        <h2 className="section-title">Page not found</h2>
        <p className="section-description">
          The page you're looking for doesn't exist. <Link to="/home">Go to the home page</Link>.
        </p>
      </div>
    </section>
  </>
)

export default NotFound
